module.exports = __webpack_public_path__ + "./Raymond_e9fc213642245813e60222e1c63bf2c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/Raymond.jpg
// module id = 504
// module chunks = 0